module.exports = __webpack_public_path__ + "static/media/close-big.e0f0c2bf.svg";